<template>
  <div class="wrap-cards">
    <div class="tree-card">
      <company-list :current.sync="current" />
    </div>
    <div class="table-card">
      <base-screen
        ref="baseScreen"
        :title="tabs"
        :defaultActiveKey="currentTab"
        :class="{'no-screen': currentTab === '1'}"
        @tabsChange="tabsChange"
      >
        <a-form style="width: auto" v-show="currentTab === '2'" :form="form" layout="inline" @submit.prevent="handleScreenSubmit">
          <a-form-item label="缴费区间">
            <a-range-picker v-decorator="['date']" />
          </a-form-item>
          <a-form-item label="单号">
            <a-input placeholder="请输入" v-decorator="['receiptNo']" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" html-type="submit">查询</a-button>
            <a-button @click="handleReset">重置</a-button>
          </a-form-item>
        </a-form>
        <a-form style="width: auto" v-show="currentTab === '3'" :form="formCollectDetail" layout="inline" @submit.prevent="handleCollectScreenSubmit">
          <a-form-item label="费用名称">
            <a-input placeholder="请输入" v-decorator="['name']" />
          </a-form-item>
          <a-form-item label="缴费日期">
            <a-range-picker v-decorator="['date']" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" html-type="submit">查询</a-button>
            <a-button @click="handleCollectDetailReset">重置</a-button>
          </a-form-item>
        </a-form>
      </base-screen>
      <cost-list v-if="currentTab === '1'" :current="current" @refresh="handleReset" />
      <collect-history ref="collectHistory" v-if="currentTab === '2'" :current="current" />
      <collect-detail-list ref="collectDetailList" v-if="currentTab === '3'" :current="current" />
    </div>
  </div>
</template>

<script>
import CompanyList from './components/CompanyList'
import CostList from './components/CostList'
import CollectHistory from './components/CollectHistory'
import CollectDetailList from './components/CollectDetailList'

export default {
  name: 'Charge',

  components: {
    CompanyList,
    CostList,
    CollectHistory,
    CollectDetailList
  },

  data () {
    return {
      current: {},
      tabs: [
        {
          name: '园区缴费',
          value: '1'
        }, {
          name: '缴费历史',
          value: '2'
        }, {
          name: '收款明细',
          value: '3'
        }
      ],
      currentTab: '1',
      form: this.$form.createForm(this),
      formCollectDetail: this.$form.createForm(this)
    }
  },

  watch: {
    current: {
      handler () {
        this.form.resetFields()
        this.formCollectDetail.resetFields()
      },
      deep: true
    }
  },

  methods: {
    async tabsChange (value) {
      this.currentTab = value
      if (value === '1') {
        this.$refs.baseScreen.contentShow = false
      } else {
        await this.$nextTick()
        this.$refs.baseScreen.updateContentHeight()
      }
    },
    handleScreenSubmit () {
      let { date, receiptNo } = this.form.getFieldsValue()
      this.$refs.collectHistory.getTableData({
        receiptNo,
        beginTime: date && date.length ? date[0].format('YYYY-MM-DD') : '',
        endTime: date && date.length ? date[1].format('YYYY-MM-DD') : ''
      })
    },
    handleReset () {
      this.form.resetFields()
      this.$refs.collectHistory.page.current = 1
      this.$refs.collectHistory.getTableData()
      this.$refs.collectDetailList.page.current = 1
      this.$refs.collectDetailList.getTableData()
    },
    handleCollectScreenSubmit () {
      let { date, name } = this.formCollectDetail.getFieldsValue()
      this.$refs.collectDetailList.getTableData({
        name,
        beginTime: date && date.length ? date[0].format('YYYY-MM-DD') : '',
        endTime: date && date.length ? date[1].format('YYYY-MM-DD') : ''
      })
    },
    handleCollectDetailReset () {
      this.formCollectDetail.resetFields()
      this.$refs.collectDetailList.page.current = 1
      this.$refs.collectDetailList.getTableData()
    }
  }
}
</script>

<style lang="less" scoped>
.wrap-cards {
  height: 100%;
}
.tree-card {
  width: 320px;
  min-height: 100%;
  user-select: none;
}
.table-card {
  flex: none;
  width: calc(100% - 322px);
  min-height: 100%;
  padding-left: 16px;
}
.no-screen ::v-deep .ant-tabs-extra-content {
  display: none;
}
</style>
